// Vue router configuration
import { createRouter, createWebHistory } from 'vue-router'
import MenuLayaout from './layout/MenuLayaout.vue'
import EmbeddedLayout from './layout/EmbeddedLayout.vue'

// Lazy load all pages and components
const HomePage = () => import('@/pages/HomePage.vue')
const ModelEditor = () => import('@/pages/ModelEditor/ModelEditor.vue')
const QueryVisualizer = () => import('@/pages/QueryVisualizer.vue')
const NotFound = () => import('@/pages/NotFound.vue')
const DashboardEditor = () => import('@/pages/Dashboard/DashboardEditor.vue')
const DashboardEmbedder = () => import('@/pages/Dashboard/DashboardEmbedder.vue')
const DashboardBrowser = () => import('@/pages/Dashboard/DashboardBrowser.vue')
const ForgotPassword = () => import('@/modules/Auth/ForgotPassword.vue')
const ResetPassword = () => import('@/modules/Auth/ResetPassword.vue')
const SignUp = () => import('@/modules/Auth/SignUp.vue')
const AccountActivation = () => import('@/modules/Auth/AccountActivation.vue')
const ActivateMessage = () => import('@/modules/Auth/ActivateMessage.vue')
const UserOnboarding = () => import('@/modules/Auth/UserOnboarding.vue')
const HelpdeskLogin = () => import('@/modules/Helpdesk/HelpdeskLogin.vue')
const CompanyManagement = () => import('@/modules/Auth/CompanyManagement.vue')
const CreateUserPage = () => import('@/modules/Auth/CreateUserPage.vue')
const LogIn = () => import('@/modules/Auth/LogIn.vue')
const LogOut = () => import('@/modules/Auth/LogOut.vue')
const MicrosoftCallback = () => import('@/modules/Auth/MicrosoftCallback.vue')
const DimensionEditor = () => import('@/components/DimensionEditor.vue')
const ProcessManager = () => import('./pages/ProcessManager/ProcessManager.vue')
const ProcessExecutor = () => import('./pages/ProcessManager/ProcessExecutor/ProcessExecutor.vue')
const ReconciliationAgentRules = () => import('./pages/ProcessManager/ProcessExecutor/ReconciliationAgentRules.vue')
const PeriodTable = () => import('./components/SettingTables/PeriodTable.vue')
const FileManager = () => import('@/components/FileManager.vue')
const HtmlViewer = () => import('@/pages/HtmlViewer.vue')
const HtmlReportPage = () => import('@/pages/HtmlReportPage.vue')
const ConnectionSource = () => import('@/pages/Conciliation/connection/ConnectionSource.vue')
const MapSchemaToSchema = () => import('@/pages/Conciliation/Mappings/cards/MapSchemaToSchema.vue')
const SchemaExcel = () => import('@/pages/Conciliation/schemas/cards/SchemaExcel.vue')
const KiplanAssistant = () => import('@/components/Assistant/KiplanAssistant.vue')
const TrainedAssistant = () => import('@/components/Assistant/TrainedAssistant.vue')
const TrainedAssistantV2 = () => import('@/components/Assistant/TrainedAssistantV2.vue')
const ObjectTable = () => import('@/components/Security/ObjectTable.vue')
const ObjectTypes = () => import('@/components/Security/ObjectTypes.vue')
const RoleTable = () => import('@/components/Security/RoleTable.vue')
const ObjectAccess = () => import('@/components/Security/ObjectAccess.vue')
const UserRole = () => import('@/components/Security/UserRole.vue')
const AccessFunction = () => import('@/components/Security/AccessFunction.vue')
const AccessFunctionRole = () => import('@/components/Security/AccessFunctionRole.vue')
const CopyData = () => import('./components/CopyData.vue')
const VueFlow = () => import('./components/MeasureGraph/VueFlow.vue')
const MatchResult = () => import('@/pages/DataIntegration/MatchResult.vue')
const ValueAnalyzer = () => import('@/pages/Dashboard/Figures/ValueAnalyzer.vue')
const VideoAssistant = () => import('@/pages/VideoAssistant/VideoAssistant.vue')
const NotificationsComp = () => import('@/components/NotificationsComp.vue')
const configProfile = () => import('@/components/Menu/ConfigProfile.vue')
const SecurityPage = () => import('@/pages/SecurityPage.vue')
import formRoutes from './modules/FormsEditor/router-form'
// Empty layout for embedded routes (no menu/chrome)


// Shared child routes — used by both /apps and /embedded
const appChildren = [
    { path: 'queryvisualizer/:modelId', component: QueryVisualizer, meta: { title: 'Query Visualizer' } },
    { path: 'ConfigProfile', component: configProfile },
    { path: 'company', component: CompanyManagement, meta: { title: 'Company Management' } },
    { path: 'users/create', component: CreateUserPage, meta: { title: 'Create User' } },
    { path: 'modeleditor/:modelId', component: ModelEditor, meta: { title: 'Model Editor' } },
    { path: 'Mapping/', component: MapSchemaToSchema },
    { path: 'schemas/', component: SchemaExcel },
    { path: 'connections/', component: ConnectionSource },
    { path: 'dashboard/editor/', component: DashboardBrowser, meta: { title: 'Dashboard Browser' } },
    { path: 'dashboard/editor/:uuid', component: DashboardEditor },
    { path: 'dashboard/:uuid', component: DashboardEmbedder },
    { path: 'dimensioneditor/:dimensionId', component: DimensionEditor, props: (route) => ({ dimensionId: parseInt(route.params.dimensionId) }) },
    { path: 'filemanager/', component: FileManager, meta: { title: 'File Manager' } },
    { path: 'processmanager/', component: ProcessManager, meta: { title: 'Process Manager' } },
    { path: 'processmanager/:task_id', component: ProcessManager, meta: { title: 'Process Manager' } },
    { path: 'processexecutor/:process_id', component: ProcessExecutor },
    { path: 'reconciliation-agent-rules/', component: ReconciliationAgentRules, meta: { title: 'Reglas del Agente de Conciliación' } },
    { path: 'assistant/:modelId', component: KiplanAssistant },
    { path: 'trained_assistant/:modelId', component: TrainedAssistant },
    { path: 'trained_assistant/', component: TrainedAssistant },
    { path: 'trained_assistant_v2/:modelId', component: TrainedAssistantV2 },
    { path: 'trained_assistant_v2/', component: TrainedAssistantV2 },
    { path: 'copydata/:modelId', component: CopyData, meta: { title: 'Copy Data' }, props: (route) => ({ model_id: parseInt(route.params.modelId) }) },

    // Security Apps
    { path: 'security', component: SecurityPage, meta: { title: 'Sesiones Activas' } },
    { path: 'ObjectTable/', component: ObjectTable, meta: { title: 'Object Manager' } },
    { path: 'ObjectTypes/', component: ObjectTypes, meta: { title: 'Object Type Manager' } },
    { path: 'RoleTable/', component: RoleTable, meta: { title: 'Role Manager' } },
    { path: 'ObjectAccess/', component: ObjectAccess, meta: { title: 'Object Access Manager' } },
    { path: 'UserRole/', component: UserRole, meta: { title: 'User Role Manager' } },
    { path: 'AccessFunction/', component: AccessFunction, meta: { title: 'Access Function Manager' } },
    { path: 'AccessFunctionRole/', component: AccessFunctionRole, meta: { title: 'Access Function Role Manager' } },

    { path: 'periodtable/', component: PeriodTable, meta: { title: 'Period Manager' } },

    // FormsEditor
    { path: 'forms/', children: formRoutes },

    { path: 'measuregraph/', component: VueFlow, meta: { title: 'Measure Graph' }, props: (route) => {
        const excaped_query = route.query.query
        return { query_inp: JSON.parse(decodeURIComponent(excaped_query)) }
    }},
    { path: 'valueanalyzer/', component: ValueAnalyzer, meta: { title: 'Value Analyzer' } },
    { path: 'video-assistant/', component: VideoAssistant, meta: { title: 'Asistente de Videos' } },
    { path: 'processeditor/', component: () => import('@/pages/ProcessManager/ProcessEditor.vue'), meta: { title: 'Process Editor' } },
    { path: 'render_user_html/:path(.*)', component: HtmlViewer, meta: { title: 'HTML Viewer' } },
    { path: 'html-report/', component: HtmlReportPage, meta: { title: 'Visor HTML' } },
]

const routes = [
    
    { path: '', component: HomePage, meta: { title: 'Kiplan Home' } },
    { path: '/accounts/login', component: LogIn },
    { path: '/accounts/signup', component: SignUp },
    { path: '/accounts/activate_message/', component: ActivateMessage },
    { path: '/accounts/activate/:uidb64/:token/', component: AccountActivation },
    { path: '/accounts/forgot-password', component: ForgotPassword },
    { path: '/accounts/reset-password', component: ResetPassword },
    { path: '/accounts/logout', component: LogOut },
    { path: '/accounts/microsoft/callback', component: MicrosoftCallback },
    { path: '/apps/onboarding', component: UserOnboarding, meta: { title: 'User Onboarding' } },
    { path: '/vue/match/:params?', component: MatchResult },
    { path: '/apps/nomenu/trained_assistant/:modelId', component: TrainedAssistant },
    // Ingreso a Helpdesk con la sesión de Kiplan (D73 del repo tickets)
    { path: '/apps/nomenu/helpdesk', component: HelpdeskLogin, meta: { title: 'Helpdesk' } },
    // With layout (menu, sidebar, etc.)
    {
        path: '/apps',
        component: MenuLayaout,
        children: appChildren,
    },

    // Without layout (embedded/iframe usage)
    {
        path: '/embedded',
        component: EmbeddedLayout,
        children: appChildren,
    },
]

const availableRoutes = routes.map(route => route.path)
// Add formRoutes to availableRoutes
formRoutes.forEach(route => availableRoutes.push('/apps/forms/' + route.path))
// Add apps
routes.find(r => r.path === '/apps').children.forEach(route => availableRoutes.push('/apps/' + route.path))

routes.find(r => r.component === MenuLayaout).children.push({ path: ':pathMatch(.*)*', component: NotFound, props: { availableRoutes } })
routes.push({ path: '/:pathMatch(.*)*', component: NotFound, props: { availableRoutes } })

const router = createRouter({
    history: createWebHistory('/'),
    routes,
})

export default router